import React from 'react'
import cx from 'clsx'
import { Link } from 'gatsby'
// Components
import { ImageBackgroundCard } from '~components/ImageBackground'
// Utils
import { lpad, splitWords } from '~utils'

const ItemCard = ({ dataIndex, item, filterSort, totalItems }) => {
  const rankWithinSort = filterSort
    ? parseInt(totalItems - dataIndex, 10)
    : item.rank

  return (
    <Link
      className={`cardLink hex-${item.categoryHex} id-${item.categoryId}`}
      itemProp="url"
      itemScope
      itemType="http://schema.org/BlogPosting"
      state={{
        modal: true,
      }}
      to={item.path}
    >
      <article className="card">
        <span
          className="anchor-tweak"
          id={`card-${'rank' === filterSort ? item.rank : rankWithinSort}`}
        />
        <ImageBackgroundCard
          imageCard={item.imageCard}
          imageCardDesktop={item.imageCardDesktop}
          imageCardMobile={item.imageCardMobile}
          imageCardPlaceholder={item.imageCardPlaceholder}
          imageCardTablet={item.imageCardTablet}
        />
        <div
          style={{
            left: '0',
            position: 'absolute',
            top: '0',
            width: '100%',
            zIndex: '5',
          }}
        >
          <h2
            className={cx(
              'cardRank',
              'card--rank',
              'rank' !== filterSort && 'cardRankSorted'
            )}
          >
            {lpad(item.rank)}
          </h2>
          <div
            className="cardCategory card--category"
            itemProp="articleSection"
          >
            <p
              className={cx(
                'cardMeta',
                'card--meta',
                3 >= item.categoryRank &&
                  'rank' === filterSort &&
                  'cardCategoryRankTopThree',
                3 >= item.categoryRank &&
                  'rank' === filterSort &&
                  'card--meta--top'
              )}
            >
              <span
                itemProp="position"
                className="cardCategoryRank card--categoryRank"
              >
                {'fanBuzz' === filterSort && (
                  <>
                    <span className="categoryHash">#</span>
                    <span>{rankWithinSort}</span>
                  </>
                )}
                {'searchScore' === filterSort && (
                  <>
                    <span className="categoryHash">#</span>
                    <span>{rankWithinSort}</span>
                  </>
                )}
                {'socialFollowing' === filterSort && (
                  <>
                    <span className="categoryHash">#</span>
                    <span>{rankWithinSort}</span>
                  </>
                )}
                {'rank' === filterSort && (
                  <>
                    <span className="categoryHash">#</span>
                    <span>{item.categoryRank}</span>
                  </>
                )}
              </span>{' '}
              <span
                className={cx(
                  'cardCategoryText',
                  item.categoryPrimary,
                  'card--categoryText'
                )}
              >
                {'fanBuzz' === filterSort && 'in Fan Vote'}
                {'rank' === filterSort && `${'in '}${item.categoryTitle}`}
                {'searchScore' === filterSort && 'in Search Score'}
                {'socialFollowing' === filterSort && 'in Social Follows'}
              </span>
            </p>
            <h3
              className="cardTitle"
              dangerouslySetInnerHTML={{ __html: splitWords(item.title) }}
              itemProp="headline"
            />
          </div>
        </div>
        <div
          itemProp="publisher"
          itemScope="itemscope"
          itemType="https://schema.org/Organization"
          className="screen-reader-text"
        >
          <meta itemProp="name" content="Fansided" />
        </div>
      </article>
    </Link>
  )
}

export default ItemCard
